export default function (state = {isAuth: false, login: {}, token: {}, user: {}, error: {}}, action) {
    switch(action.type) {
        case "FIELD_UPDATE":
            state.login[action.field] = action.value;
            return { ...state };
        case "LOGGED_IN":
            state.isAuth = true;
            //state.login = {};
            state.user = action.data.user_data;
            state.token = action.data.token_data;
            return { ...state };
        case "TOKEN_REFRESHED":
            state.isAuth = true;
            state.token = action.data.token_data;
            return { ...state };
        case "TOKEN_REFRESH_FAILED":
            state.isAuth = false;
            state.login = {};
            state.token = {};
            state.user = {};
            return { ...state };
        case "ERROR_LOGIN":
            state.isAuth = false;
            state.login = {};
            state.token = {};
            state.user = {};
            state.error['message'] = 'Authentification failed';
            return { ...state };
        case "LOGOUT":
            state.isAuth = false;
            state.login = {};
            state.token = {};
            state.user = {};
            state.error = {};
            return { ...state };
        default:
            break;
    }
    return state;
}

